import * as tslib_1 from "tslib";
import { refineProps, parseBusinessHours, processScopedUiProps } from '@fullcalendar/core';
var RESOURCE_PROPS = {
    id: String,
    title: String,
    parentId: String,
    businessHours: null,
    children: null,
    extendedProps: null
};
var PRIVATE_ID_PREFIX = '_fc:';
var uid = 0;
/*
needs a full store so that it can populate children too
*/
export function parseResource(input, parentId, store, calendar) {
    if (parentId === void 0) { parentId = ''; }
    var leftovers0 = {};
    var props = refineProps(input, RESOURCE_PROPS, {}, leftovers0);
    var leftovers1 = {};
    var ui = processScopedUiProps('event', leftovers0, calendar, leftovers1);
    if (!props.id) {
        props.id = PRIVATE_ID_PREFIX + (uid++);
    }
    if (!props.parentId) { // give precedence to the parentId property
        props.parentId = parentId;
    }
    props.businessHours = props.businessHours ? parseBusinessHours(props.businessHours, calendar) : null;
    props.ui = ui;
    props.extendedProps = tslib_1.__assign({}, leftovers1, props.extendedProps);
    // help out ResourceApi from having user modify props
    Object.freeze(ui.classNames);
    Object.freeze(props.extendedProps);
    if (store[props.id]) {
        // console.warn('duplicate resource ID')
    }
    else {
        store[props.id] = props;
        if (props.children) {
            for (var _i = 0, _a = props.children; _i < _a.length; _i++) {
                var childInput = _a[_i];
                parseResource(childInput, props.id, store, calendar);
            }
            delete props.children;
        }
    }
    return props;
}
/*
TODO: use this in more places
*/
export function getPublicId(id) {
    if (id.indexOf(PRIVATE_ID_PREFIX) === 0) {
        return '';
    }
    return id;
}
